// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { Vec3Wire, Vec3WireT } from '../mannequin/vec3-wire';


export class BallPitchDataTrajectoryDataWire implements flatbuffers.IUnpackableObject<BallPitchDataTrajectoryDataWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):BallPitchDataTrajectoryDataWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsBallPitchDataTrajectoryDataWire(bb:flatbuffers.ByteBuffer, obj?:BallPitchDataTrajectoryDataWire):BallPitchDataTrajectoryDataWire {
  return (obj || new BallPitchDataTrajectoryDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsBallPitchDataTrajectoryDataWire(bb:flatbuffers.ByteBuffer, obj?:BallPitchDataTrajectoryDataWire):BallPitchDataTrajectoryDataWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new BallPitchDataTrajectoryDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

verticalBreak():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

verticalBreakInduced():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

horizontalBreak():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

location(obj?:Vec3Wire):Vec3Wire|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new Vec3Wire()).__init(this.bb_pos + offset, this.bb!) : null;
}

zoneSpeed():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

verticalApproachAngle():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

horizontalApproachAngle():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

zoneTime():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

trajectoryPolynomialX(obj?:Vec3Wire):Vec3Wire|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new Vec3Wire()).__init(this.bb_pos + offset, this.bb!) : null;
}

trajectoryPolynomialY(obj?:Vec3Wire):Vec3Wire|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new Vec3Wire()).__init(this.bb_pos + offset, this.bb!) : null;
}

trajectoryPolynomialZ(obj?:Vec3Wire):Vec3Wire|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new Vec3Wire()).__init(this.bb_pos + offset, this.bb!) : null;
}

static startBallPitchDataTrajectoryDataWire(builder:flatbuffers.Builder) {
  builder.startObject(11);
}

static addVerticalBreak(builder:flatbuffers.Builder, verticalBreak:number) {
  builder.addFieldFloat32(0, verticalBreak, 0.0);
}

static addVerticalBreakInduced(builder:flatbuffers.Builder, verticalBreakInduced:number) {
  builder.addFieldFloat32(1, verticalBreakInduced, 0.0);
}

static addHorizontalBreak(builder:flatbuffers.Builder, horizontalBreak:number) {
  builder.addFieldFloat32(2, horizontalBreak, 0.0);
}

static addLocation(builder:flatbuffers.Builder, locationOffset:flatbuffers.Offset) {
  builder.addFieldStruct(3, locationOffset, 0);
}

static addZoneSpeed(builder:flatbuffers.Builder, zoneSpeed:number) {
  builder.addFieldFloat32(4, zoneSpeed, 0.0);
}

static addVerticalApproachAngle(builder:flatbuffers.Builder, verticalApproachAngle:number) {
  builder.addFieldFloat32(5, verticalApproachAngle, 0.0);
}

static addHorizontalApproachAngle(builder:flatbuffers.Builder, horizontalApproachAngle:number) {
  builder.addFieldFloat32(6, horizontalApproachAngle, 0.0);
}

static addZoneTime(builder:flatbuffers.Builder, zoneTime:number) {
  builder.addFieldFloat32(7, zoneTime, 0.0);
}

static addTrajectoryPolynomialX(builder:flatbuffers.Builder, trajectoryPolynomialXOffset:flatbuffers.Offset) {
  builder.addFieldStruct(8, trajectoryPolynomialXOffset, 0);
}

static addTrajectoryPolynomialY(builder:flatbuffers.Builder, trajectoryPolynomialYOffset:flatbuffers.Offset) {
  builder.addFieldStruct(9, trajectoryPolynomialYOffset, 0);
}

static addTrajectoryPolynomialZ(builder:flatbuffers.Builder, trajectoryPolynomialZOffset:flatbuffers.Offset) {
  builder.addFieldStruct(10, trajectoryPolynomialZOffset, 0);
}

static endBallPitchDataTrajectoryDataWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): BallPitchDataTrajectoryDataWireT {
  return new BallPitchDataTrajectoryDataWireT(
    this.verticalBreak(),
    this.verticalBreakInduced(),
    this.horizontalBreak(),
    (this.location() !== null ? this.location()!.unpack() : null),
    this.zoneSpeed(),
    this.verticalApproachAngle(),
    this.horizontalApproachAngle(),
    this.zoneTime(),
    (this.trajectoryPolynomialX() !== null ? this.trajectoryPolynomialX()!.unpack() : null),
    (this.trajectoryPolynomialY() !== null ? this.trajectoryPolynomialY()!.unpack() : null),
    (this.trajectoryPolynomialZ() !== null ? this.trajectoryPolynomialZ()!.unpack() : null)
  );
}


unpackTo(_o: BallPitchDataTrajectoryDataWireT): void {
  _o.verticalBreak = this.verticalBreak();
  _o.verticalBreakInduced = this.verticalBreakInduced();
  _o.horizontalBreak = this.horizontalBreak();
  _o.location = (this.location() !== null ? this.location()!.unpack() : null);
  _o.zoneSpeed = this.zoneSpeed();
  _o.verticalApproachAngle = this.verticalApproachAngle();
  _o.horizontalApproachAngle = this.horizontalApproachAngle();
  _o.zoneTime = this.zoneTime();
  _o.trajectoryPolynomialX = (this.trajectoryPolynomialX() !== null ? this.trajectoryPolynomialX()!.unpack() : null);
  _o.trajectoryPolynomialY = (this.trajectoryPolynomialY() !== null ? this.trajectoryPolynomialY()!.unpack() : null);
  _o.trajectoryPolynomialZ = (this.trajectoryPolynomialZ() !== null ? this.trajectoryPolynomialZ()!.unpack() : null);
}
}

export class BallPitchDataTrajectoryDataWireT implements flatbuffers.IGeneratedObject {
constructor(
  public verticalBreak: number = 0.0,
  public verticalBreakInduced: number = 0.0,
  public horizontalBreak: number = 0.0,
  public location: Vec3WireT|null = null,
  public zoneSpeed: number = 0.0,
  public verticalApproachAngle: number = 0.0,
  public horizontalApproachAngle: number = 0.0,
  public zoneTime: number = 0.0,
  public trajectoryPolynomialX: Vec3WireT|null = null,
  public trajectoryPolynomialY: Vec3WireT|null = null,
  public trajectoryPolynomialZ: Vec3WireT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  BallPitchDataTrajectoryDataWire.startBallPitchDataTrajectoryDataWire(builder);
  BallPitchDataTrajectoryDataWire.addVerticalBreak(builder, this.verticalBreak);
  BallPitchDataTrajectoryDataWire.addVerticalBreakInduced(builder, this.verticalBreakInduced);
  BallPitchDataTrajectoryDataWire.addHorizontalBreak(builder, this.horizontalBreak);
  BallPitchDataTrajectoryDataWire.addLocation(builder, (this.location !== null ? this.location!.pack(builder) : 0));
  BallPitchDataTrajectoryDataWire.addZoneSpeed(builder, this.zoneSpeed);
  BallPitchDataTrajectoryDataWire.addVerticalApproachAngle(builder, this.verticalApproachAngle);
  BallPitchDataTrajectoryDataWire.addHorizontalApproachAngle(builder, this.horizontalApproachAngle);
  BallPitchDataTrajectoryDataWire.addZoneTime(builder, this.zoneTime);
  BallPitchDataTrajectoryDataWire.addTrajectoryPolynomialX(builder, (this.trajectoryPolynomialX !== null ? this.trajectoryPolynomialX!.pack(builder) : 0));
  BallPitchDataTrajectoryDataWire.addTrajectoryPolynomialY(builder, (this.trajectoryPolynomialY !== null ? this.trajectoryPolynomialY!.pack(builder) : 0));
  BallPitchDataTrajectoryDataWire.addTrajectoryPolynomialZ(builder, (this.trajectoryPolynomialZ !== null ? this.trajectoryPolynomialZ!.pack(builder) : 0));

  return BallPitchDataTrajectoryDataWire.endBallPitchDataTrajectoryDataWire(builder);
}
}
